import { render, staticRenderFns } from "./ParentFeedback.vue?vue&type=template&id=eba9bc86&scoped=true"
import script from "./ParentFeedback.vue?vue&type=script&lang=js"
export * from "./ParentFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eba9bc86",
  null
  
)

export default component.exports